import i from "lodash/includes";
import "../../types/authenticator/user.js";
import { LoginMechanismArray as n } from "../../types/authenticator/attributes.js";
var r = function r(i) {
    var n,
      r = null === (n = null == i ? void 0 : i.context.config) || void 0 === n ? void 0 : n.loginMechanisms;
    return (null != r ? r : ["username"])[0];
  },
  t = function t(r) {
    var t,
      o = (null === (t = r.config) || void 0 === t ? void 0 : t.loginMechanisms).filter(function (r) {
        return i(n, r);
      });
    return {
      primaryAlias: o[0],
      secondaryAliases: o.slice(1)
    };
  };
export { t as getConfiguredAliases, r as getPrimaryAlias };